import { API, Router } from "../Helpers";
import { NextArrow, PrevArrow, ReviewRating } from "../Shared";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import Slider from "react-slick";

export default class ToursCleanCarousel extends Component {
  constructor(props) {
    super(props);

    const { filtered_locations } = this.props.data;

    if (!_.isEmpty(filtered_locations)) {
      this.props.data.locations.data = filtered_locations;
    }
    // console.log(this.props.data.locations.data);

    this.state = {
      cart: this.props.data.cart,
      location: _.find(this.props.data.locations.data, (_location) => {
        return _location.slug == this.props.data.payload.location;
      }),
      tours: this.props.data.tours,
      sort_by: this.props.data.sort_by,
    };

    this.changeLocation = this.changeLocation.bind(this);
    this.changeSortBy = this.changeSortBy.bind(this);
    this.findProductCoverPhoto = this.findProductCoverPhoto.bind(this);
    this.findTourListingCtaText = this.findTourListingCtaText.bind(this);
    this.generateProductUrl = this.generateProductUrl.bind(this);
    this.getLocationOptions = this.getLocationOptions.bind(this);
    this.inCart = this.inCart.bind(this);
    this.nextCount = this.nextCount.bind(this);
    this.showLoader = this.showLoader.bind(this);
    this.loadMoreTours = this.loadMoreTours.bind(this);
    this.toCount = this.toCount.bind(this);
    this.urlParams = this.urlParams.bind(this);
  }

  componentDidMount() {
    //update selection location from destination param
    const searchParams = new URLSearchParams(document.location.search);
    // console.log("category", searchParams.get('destination'));
    const slug = searchParams.get("destination");
    const location = _.find(this.props.data.locations.data, (_location) => {
      return _location.slug == slug;
    });

    if (location) this.changeLocation(location);
  }

  changeLocation(location) {
    //console.log("changeLocation", location);

    this.setState(
      {
        location: location,
      },
      () => {
        this.updateTours();
        const searchParams = new URLSearchParams(document.location.search);
        searchParams.set("destination", location.slug);
        const newUrl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?" +
          searchParams.toString();

        window.history.pushState({ path: newUrl }, "", newUrl);
      }
    );
  }

  changeSortBy(sort_by) {
    this.setState(
      {
        sort_by: sort_by,
      },
      () => {
        this.updateTours();
      }
    );
  }

  findProductCoverPhoto(tour) {
    if (!_.isEmpty(tour.cover_photo)) {
      return tour.cover_photo.medium;
    }

    return "/images/placeholder-16-9.jpg";
  }

  findTourListingCtaText() {
    let tour_listing_cta_text = _.find(
      this.props.data.active_site.settings.data,
      (_setting) => {
        return _setting.key == "tour_listing_cta_text";
      }
    );

    if (!_.isEmpty(tour_listing_cta_text)) {
      return tour_listing_cta_text.value;
    }
  }

  generateProductUrl(tour) {
    const router = Router(this.props.data.routes);

    let params = {
      domain: this.props.data.active_site.domain,
      id: tour.id,
      tour_slug: tour.slug,
    };

    if (!_.isEmpty(this.state.location)) {
      if (
        !_.isEmpty(this.state.location.region_slug) &&
        !_.isNull(this.state.location.region_slug)
      ) {
        params.region_slug = this.state.location.region_slug;

        if (
          !_.isEmpty(this.state.location.country_slug) &&
          !_.isNull(this.state.location.country_slug)
        ) {
          params.country_slug = this.state.location.country_slug;

          return router.url("tours.show_region", params);
        }
      }

      if (
        !_.isEmpty(this.state.location.country_slug) &&
        !_.isNull(this.state.location.country_slug)
      ) {
        params.country_slug = this.state.location.country_slug;

        return router.url("tours.show_country", params);
      }
    }

    return router.url("tours.show", params);
  }

  getLocationOptions() {
    let location_options = [];

    _.forEach(this.props.data.locations.data, (location) => {
      location.label = location.name;
      location.value = location.slug;

      location_options.push(location);
    });

    return _.sortBy(location_options, ["label"]);
  }

  inCart(tour) {
    let index = _.findIndex(this.state.cart.items, (_item) => {
      return tour.name == _item.name;
    });

    if (index > -1) {
      return true;
    }

    return false;
  }

  nextCount() {
    if (
      this.state.tours.meta.pagination.total -
        this.state.tours.meta.pagination.current_page *
          this.state.tours.meta.pagination.per_page <
      this.state.tours.meta.pagination.per_page
    ) {
      return (
        this.state.tours.meta.pagination.total -
        this.state.tours.meta.pagination.current_page *
          this.state.tours.meta.pagination.per_page
      );
    }

    return this.state.tours.meta.pagination.per_page;
  }

  showLoader() {
    //console.log("showLoader");

    this.setState({
      show_loader: true,
    });
  }

  loadMoreTours(page) {
    //console.log("loadMoreTours");

    const router = Router(this.props.data.routes);

    let payload = this.urlParams(page);

    //console.log("payload", payload);

    let onResponse = {
      success: (response) => {
        //console.log("loadMoreTours response", response);

        let tours = { ...this.state.tours };

        tours.data = tours.data.concat(response.data);
        tours.meta = response.meta;

        this.setState({
          tours: tours,
          loading_more_tours: false,
        });
      },
      error: (error) => {
        console.log("error", error);
      },
      complete: () => {
        console.log("complete");
      },
    };

    this.setState(
      {
        loading_more_tours: true,
      },
      () => {
        API.get(onResponse, router.url("api.tours.index", payload));
      }
    );
  }

  updateTours() {
    //console.log("updateTours");

    const router = Router(this.props.data.routes);

    let payload = this.urlParams();

    //console.log("payload", payload);

    let onResponse = {
      success: (response) => {
        //console.log("updateTours response", response);

        this.setState({
          tours: response,
          show_loader: false,
        });
      },
      error: (error) => {
        console.log("error", error);
      },
      complete: () => {
        console.log("complete");
      },
    };

    this.setState(
      {
        show_loader: true,
      },
      () => {
        API.get(onResponse, router.url("api.tours.index", payload));
      }
    );
  }

  toCount() {
    return this.state.tours.meta.pagination.current_page *
      this.state.tours.meta.pagination.per_page <
      this.state.tours.meta.pagination.total
      ? this.state.tours.meta.pagination.current_page *
          this.state.tours.meta.pagination.per_page
      : this.state.tours.meta.pagination.total;
  }

  urlParams(page) {
    let params = _.omit(this.props.data.payload, ["location", "sort_by"]);

    params = _.assign({ sort_by: this.state.sort_by.slug }, params);

    if (!_.isEmpty(this.state.location)) {
      params = _.assign({ location: this.state.location.slug }, params);
    }

    if (page > 1) {
      params = _.assign({ page: page }, params);
    }

    return params;
  }

  render() {
    const {
      active_site,
      locations,
      order_by_options,
      request,
      routes,
    } = this.props.data;
    const router = Router(routes);
    const tour_listing_cta_text = this.findTourListingCtaText();

    const slidesToScroll = Math.min(3, this.state.tours.data.length);
    return (
      <div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Select
                options={this.getLocationOptions()}
                onChange={(value) => {
                  this.changeLocation(value);
                }}
                value={
                  !_.isEmpty(this.state.location) ? this.state.location : ""
                }
                placeholder="Choose Your Destination"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    padding: "0.5rem",
                  }),
                }}
              />
            </div>
          </div>
        </div>

        {!_.isEmpty(this.state.tours.data) && (
          <div className="row mb-9">
            <div className="col-12">
              <Slider
                {...{
                  className: "slick-carousel h-100",
                  infinite: true,
                  initialSlide: 0,
                  slidesToShow: slidesToScroll,
                  slidesToScroll: slidesToScroll,
                  prevArrow: <PrevArrow theme="minimal" />,
                  nextArrow: <NextArrow theme="minimal" />,
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: slidesToScroll,
                        slidesToScroll: slidesToScroll,
                      },
                    },
                    {
                      breakpoint: 1024,
                      settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: "20px",
                        slidesToShow: 2,
                        slidesToScroll: 2,
                      },
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: "20px",
                        slidesToShow: 1,
                        slidesToScroll: 1,
                      },
                    },
                  ],
                }}
              >
                {this.state.tours.data.map((tour, key) => {
                  const product_url = this.generateProductUrl(tour);
                  const product_cover_photo = this.findProductCoverPhoto(tour);

                  // console.log("tour", tour);
                  let duration;

                  if (
                    !_.isEmpty(tour.date_settings) &&
                    !_.isEmpty(tour.date_settings.duration)
                  ) {
                    const matches = tour.date_settings.duration.match(
                      /(\d*\.)?\d+ (hours|hrs) ?(\d+ ?mins)?/i
                    );
                    duration =
                      !_.isEmpty(matches) > 0
                        ? matches[0].replace(/hours/gi, "hrs")
                        : null;
                  }

                  return (
                    <div key={key} className="position-relative h-100">
                      <a href={product_url} className="d-flex h-100">
                        <div
                          className="card rounded-0 shadow-none px-2"
                          style={{ background: "none" }}
                        >
                          <div className="card-image overflow-hidden position-relative">
                            <img
                              className="img-fluid"
                              src={product_cover_photo}
                            />

                            {this.inCart(tour) && (
                              <div
                                className="position-absolute card z-depth-0 border-black"
                                style={{ top: "10px", right: "10px" }}
                                tabIndex="0"
                              >
                                <div className="card-body text-center p-2 black primary-text">
                                  <i className="fa fa-shopping-cart mr-2"></i>
                                  <i className="fa fa-check"></i>
                                </div>
                              </div>
                            )}
                          </div>

                          <div className="card-body pl-0 pr-0 py-3 text-left position-relative">
                            {!_.isEmpty(duration) && (
                              <div>
                                <span
                                  className="body-text-color text-uppercase truncate-1"
                                  style={{ fontWeight: 300 }}
                                >
                                  approx: {duration}
                                </span>
                              </div>
                            )}

                            <h5
                              className="three-b-text font-weight-bold body-font mb-3 truncate-2 text-uppercase d-lg-webkit-box line-clamp"
                              style={{ WebkitLineClamp: 3 }}
                            >
                              {tour.name}
                            </h5>

                            {/* <h5 className="three-b-text font-weight-bold body-font mb-3 truncate-2 d-lg-none">
                                {tour.name}
                            </h5> */}

                            <div
                              class="body-text-color line-clamp"
                              style={{
                                height: "7.5em",
                                maxHeight: "7.5em",
                                WebkitLineClamp: 5,
                                fontWeight: 300,
                              }}
                            >
                              {tour.overview.replace(/<[^>]*>?/gm, "")}
                            </div>
                          </div>

                          <div
                            className="card-footer d-flex pl-0 pr-0 justify-content-between"
                            style={{ borderTop: "none", background: "none" }}
                          >
                            <ReviewRating
                              star_rating={
                                !_.isNull(tour.average_rating)
                                  ? tour.average_rating
                                  : 0
                              }
                              count={tour.reviews_count}
                              label={false}
                              size="small"
                            />
                            {!_.isEmpty(tour_listing_cta_text) && (
                              <div className="text-right">
                                <button
                                  className="btn btn-link primary-text p-0"
                                  style={{ fontWeight: 400 }}
                                >
                                  <span class="text-uppercase">
                                    {tour_listing_cta_text}
                                  </span>
                                  <i className="fa fa-angle-right ml-2"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </a>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        )}

        {this.state.show_loader && (
          <div
            className="view viewport-height position-fixed three-b opacity-75 w-100 z-max"
            style={{ left: 0, top: 0, bottom: 0, right: 0 }}
          >
            <div className="progress md-progress primary-color z-3 mb-0">
              <div className="indeterminate"></div>
            </div>

            <div className="mask d-flex justify-content-center align-items-center">
              <div className="preloader-wrapper active crazy">
                <div className="spinner-layer spinner-red-only spinner-primary">
                  <div className="circle-clipper left">
                    <div className="circle"></div>
                  </div>
                  <div className="gap-patch">
                    <div className="circle"></div>
                  </div>
                  <div className="circle-clipper right">
                    <div className="circle"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

if (document.getElementById("toursCleanCarousel")) {
  const element = document.getElementById("toursCleanCarousel");
  const data = Object.assign({}, element.dataset);

  //console.log(data.data);

  ReactDOM.render(
    <ToursCleanCarousel data={JSON.parse(data.data)} />,
    document.getElementById("toursCleanCarousel")
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/Shortcodes/ToursCleanCarousel.js